import React, { useContext, useMemo } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Badge from '@mui/material/Badge'
import { useNavigate } from 'react-router-dom'
import { drawerWidth } from '..'
import ReturnLinkAndActiveEnterprise from './returnLinkAndActiveEnterperise'
import DropDownMenu from './dropDownMenu'
import { ActiveRegionContext } from '../../../context/activeRegionContext'
import { CartContext } from '../../../context/cartContext'
import { useImpersonation } from '../../../context/impersonationContext'
import ShoppingCart from './shoppingCart'
import NotificationBellIcon from '../../../icons/notificationBellIcon'
import { useGetCommunications } from '../../../hooks/api/communications'


const DesktopHeader = () => {
  const { activeRegion } = useContext(ActiveRegionContext)
  const { cart } = useContext(CartContext)
  const { isImpersonating } = useImpersonation()
  const navigate = useNavigate()
  const { data: communications } = useGetCommunications()

  const handleNavigateToCommunications = () => {
    navigate('/communications')
  }

  // Calculate unread communications count
  const unreadCount = useMemo(() => {
    if (!communications || !Array.isArray(communications)) return 0
    
    try {
      const readCommunications = JSON.parse(localStorage.getItem('readCommunications') || '[]')
      return communications.filter(comm => !readCommunications.includes(comm.id)).length
    } catch {
      return communications.length
    }
  }, [communications])

  return (
    <AppBar
      position='fixed'
      sx={{
        backgroundColor: 'primary.lighter',
        boxShadow: 'none',
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        top: isImpersonating ? '60px' : '0px',
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          minHeight: 'auto!important',
          py: '15px',
          pl: '20px!important',
          pr: '0!important',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ReturnLinkAndActiveEnterprise />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant='h6'
            component='a'
            sx={{ mr: '34px', textDecoration: 'none' }}
            href={`${process.env.REACT_APP_JOIN_US}?regionid=${activeRegion}`}
          >
            Nous joindre
          </Typography>
          <IconButton
            onClick={handleNavigateToCommunications}
            sx={{
              mr: '20px',
              '&:hover': {
                backgroundColor: 'primary.light',
              },
              '&:hover svg path': {
                fill: '#fff',
              },
            }}
            aria-label="Communications"
          >
            <Badge 
              badgeContent={unreadCount} 
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.7rem',
                  height: '18px',
                  minWidth: '18px',
                  padding: '0 4px',
                },
              }}
            >
              <NotificationBellIcon />
            </Badge>
          </IconButton>
          <DropDownMenu />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ShoppingCart content={(cart !== null) ? cart : 0} isMobile={false} />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default DesktopHeader
